declare global {
  interface Window {
    __APP_CONFIG__: Record<string, string> | undefined;
  }
}

export function getRuntimeConfig(key: string): string {
  const cfg = window.__APP_CONFIG__;
  if (cfg && key in cfg) return cfg[key];
  return (import.meta.env[`VITE_${key}`] as string) ?? "";
}
